module.exports = __webpack_public_path__ + "img/20.6ba52053.svg";